import React, { useState, useEffect, useReducer } from "react";
import TitleBar from "./TitleBar";
import Modal from "react-modal";
import { getFormText } from "../contentful";
import marked from "marked";
import { initialState, reducer } from "./FormReducer";
import { validateAddress, validateEmail, validateMinLength, validatePhoneNumber, validateWebsite } from "../utils/formValidation";
import generateApplicationPdf from "../utils/generateApplicationPdf";

const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = String(reader.result || "");
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

const ApplicationForm2 = (props) => {
  const [expConfirmed, setExpConfirmed] = useState(true);
  const [incConfirmed, setIncConfirmed] = useState(true);

  //Text area inputs
  const [formText, setFormText] = useState("");
  const [wordOverflow, setWordOverflow] = useState(0);
  const [wordCounts, setWordCounts] = useState({});

  //Financial Inputs
  const [expensesInputList, setExpensesInputList] = useState([
    { Expenditure: "", Details: "", Cost: 0, Clicked: false },
  ]);
  const [incomeInputList, setIncomeInputList] = useState([{ Income: "", Confirmed: "", Amount: 0, Clicked: false }]);
  const [totalExpense, setTotalExpense] = useState(0);
  const [totalIncome, setTotalIncome] = useState(0);

  //Error handling 
  const [errorMessage, setErrorMessage] = useState({})

  const [state, dispatch] = useReducer(reducer, initialState);

  // Submission state
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const handleTextInput = (e) => {
    window.localStorage.setItem(e.target.name, e.target.value);
    dispatch({ type: e.target.name, payload: e.target.value });
  };

  const getInfoFromLocalStorage = () => {
    dispatch({
      type: "organisation",
      payload: window.localStorage.organisation,
    });
    dispatch({ type: "address", payload: window.localStorage.address });
    dispatch({ type: "charity", payload: window.localStorage.charity });
    dispatch({ type: "name", payload: window.localStorage.name });
    dispatch({ type: "position", payload: window.localStorage.position });
    dispatch({ type: "tel", payload: window.localStorage.tel });
    dispatch({ type: "email", payload: window.localStorage.email });
    dispatch({ type: "website", payload: window.localStorage.website });
    dispatch({ type: "fundingrequested", payload: window.localStorage.fundingrequested });
    dispatch({ type: "liability", payload: window.localStorage.liability });
    dispatch({
      type: "safeguarding",
      payload: window.localStorage.safeguarding,
    });
    dispatch({ type: "about", payload: window.localStorage.about });
    dispatch({ type: "project", payload: window.localStorage.project });
    dispatch({ type: "timeframe", payload: window.localStorage.timeframe });
    dispatch({ type: "outreach", payload: window.localStorage.outreach });
    dispatch({ type: "demand", payload: window.localStorage.demand });
    dispatch({ type: "impact", payload: window.localStorage.impact });
    dispatch({ type: "evaluation", payload: window.localStorage.evaluation });
  };

  useEffect(() => {
    getFormText().then((data) => setFormText(data[0].fields.content));
    getInfoFromLocalStorage();
  }, []);


  const handleInputChange = (e) => {
    const { name, value } = e.target

    let error = '';

    if (!value.trim()) {
      error = "Please complete this information."
    }

    if (name === 'organisation' || name === 'name' || name === 'position') {
      error = validateMinLength(name, value, 3)
    }

    if (name === 'address') {
      error = validateAddress(value)
    }
    if (name === "charity") {
      error = validateMinLength(name, value, 6)
    }

    if (name === "tel") {
      error = validatePhoneNumber(value, 10, 11)
    }

    if (name === "email") {
      error = validateEmail(value)
    }

    if (name === 'website') {
      error = validateWebsite(value)
    }

    setErrorMessage((prev) => ({
      ...prev,
      [name]: error,
    }));
  }

  const handleTextArea = (e, wordCount) => {
    const { name, value } = e.target;

    localStorage.setItem(name, value);
    dispatch({ type: name, payload: value });

    const words = value.trim().split(/\s+/).filter(Boolean).length;
    const overflow = Math.max(0, words - wordCount);

    setWordCounts((prev) => ({
      ...prev,
      [name]: words,
    }));

    setWordOverflow((prev) => ({
      ...prev,
      [name]: overflow,
    }));
  }

  const handleTextAreaBlur = (e) => {

    const { name, value } = e.target;

    let error = "";

    if (!value.trim()) {
      error = "Please complete this information.";
    }

    setErrorMessage((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleFinanceInputChange = (e, index, type, fieldName) => {
    const value  = e.target.value;

    if (type === 'expenses') {
      const list = [...expensesInputList];
      list[index][fieldName] = value;

      setExpensesInputList(list);
      localStorage.setItem(fieldName + index, value);
    }

    if (type === 'income') {
      const list = [...incomeInputList];
      list[index][fieldName] = value;
      setIncomeInputList(list);
      console.log(list);
      localStorage.setItem(fieldName + index, value);
    }

  };

  const handleAddEntry = (e, type) => {
    e.preventDefault();
    if (type === 'income') {
      setIncomeInputList([...incomeInputList, { Income: "", Confirmed: "", Amount: 0, Clicked: false }]);
    } else {
      setExpensesInputList([...expensesInputList, { Expenditure: "", Details: "", Cost: 0, Clicked: false }]);
    };
  }

  const handleRemoveEntry = (event, type, index) => {
    event.preventDefault();
    if (type.Expenditure) {
      const list = [...expensesInputList];
      list.splice(index, 1);
      setExpensesInputList(list);
      let total = totalExpense - +type.Cost;
      setTotalExpense(total);
    }
    if (type.Income) {
      const list = [...incomeInputList];
      list.splice(index, 1);
      setIncomeInputList(list);
      let total = totalIncome - +type.Amount;
      setTotalIncome(total);
    }
  };

  const handleTotalExp = (event, exp, index) => {
    event.preventDefault();

    const array = [...expensesInputList];
    array[index].Clicked = true;
    setExpensesInputList(array);

    const runningTotal = array.reduce((acc, item) => {
      acc += Number(item.Cost ?? 0);;
      return acc;
    }, 0);
    setTotalExpense(runningTotal);
    localStorage.setItem("totalExp", runningTotal.toString());
    setExpConfirmed(true);
  };

  const handleTotalInc = (e, exp, index) => {
    e.preventDefault();

    const array = [...incomeInputList];
    array[index].Clicked = true;
    setIncomeInputList(array);
    const runningTotal = array.reduce((acc, item) => {
      acc += Number(item.Amount ?? 0);
      return acc;
    }, 0);

    const confirmed = array.reduce((acc, item) => {
      if (item.Confirmed === "Confirmed") {
        acc += Number(item.Amount ?? 0);
        return acc;
      }
      return acc;
    }, 0);

    const pending = array.reduce((acc, item) => {
      if (item.Confirmed === "Pending") {
        acc += Number(item.Amount ?? 0);
        return acc;
      }
      return acc;
    }, 0);

    setTotalIncome(runningTotal);
    dispatch({ type: "total-income", payload: runningTotal });
    dispatch({ type: "total-confirmed-income", payload: confirmed });
    dispatch({ type: "total-pending-income", payload: pending });
    localStorage.setItem("totalInc", runningTotal.toString());
    setIncConfirmed(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    // Honeypot: silently "succeed" if a bot filled the hidden field.
    const honeypot = e.target.elements._gotcha?.value;
    if (honeypot) {
      setSubmitted(true);
      return;
    }

    setSubmitting(true);
    setSubmitError(null);
    try {
      const pdfBlob = generateApplicationPdf({
        fields: state,
        expenses: expensesInputList,
        income: incomeInputList,
        totalExpense,
        totalIncome,
        confirmedIncome: state.confirmedIncome,
        pendingIncome: state.pendingIncome,
      });
      const pdfBase64 = await blobToBase64(pdfBlob);
      const slug = (state.organisation || "Untitled")
        .replace(/[^a-zA-Z0-9._-]+/g, "-") // disallowed runs -> hyphen (case kept)
        .replace(/[-_.]{2,}/g, "-") // collapse repeated separators
        .replace(/^[-_.]+|[-_.]+$/g, ""); // trim leading/trailing separators
      const filename = `Application-${slug || "Untitled"}.pdf`;

      const res = await fetch("/.netlify/functions/submit-application", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ fields: state, pdfBase64, filename }),
      });

      if (!res.ok) {
        throw new Error(`Request failed (${res.status})`);
      }
      setSubmitted(true);
    } catch (err) {
      setSubmitError(
        "Sorry, we couldn't submit your application. Please try again, or email us directly at lucillegtrust@gmail.com."
      );
    } finally {
      setSubmitting(false);
    }
  };

  // Gate the Submit button on the same required-field checks as before.
  const requiredFieldsMissing =
    state.organisation === "" ||
    state.name === "" ||
    state.address === "" ||
    state.charity === "" ||
    state.name === "" ||
    state.position === "" ||
    state.tel === "" ||
    state.email === "" ||
    state.website === "" ||
    state.fundingrequested === "" ||
    state.liability === "" ||
    state.safeguarding === "" ||
    state.about === "" ||
    state.project === "" ||
    state.timeframe === "" ||
    state.outreach === "" ||
    state.demand === "" ||
    state.impact === "" ||
    state.evaluation === "" ||
    expensesInputList[0].Cost === 0 ||
    expensesInputList[0].Expenditure === "" ||
    expensesInputList[0].Details === "" ||
    incomeInputList[0].Income === "" ||
    incomeInputList[0].Confirmed === "" ||
    incomeInputList[0].Amount === 0 ||
    incomeInputList.some((item) => !item.Clicked) ||
    expensesInputList.some((item) => !item.Clicked);
  return (
    <>
      <Modal isOpen={props.openModal}
        closeTimeoutMS={200}
        style={{
          overlay: { backgroundColor: "rgba(0, 0, 0, .5)" },
        }}
      >
        <TitleBar title='Apply Online' />

        <div className='content' id='pdf-view'>
          <div dangerouslySetInnerHTML={{ __html: marked(formText) }}></div>
          <hr></hr>

          <div>
            <h4 style={{ marginBottom: 25 }}>Application Form</h4>

            <form className='application-form' onSubmit={handleSubmit}>
              <input type="text" name="_gotcha" tabIndex={-1} autoComplete="off" hidden aria-hidden="true" />
              Organisation
              <input onBlur={(e) => handleInputChange(e)} onChange={handleTextInput} required type='text' value={state.organisation} name='organisation' />
              {errorMessage && <p style={{ color: "red" }}>{errorMessage.organisation}</p>}
              Address
              <textarea rows={4} onBlur={(e) => handleInputChange(e)} onChange={handleTextInput} required value={state.address} name='address' />
              {errorMessage && <p style={{ color: "red" }}>{errorMessage.address}</p>}
              Charity / company no.
              <input required onBlur={(e) => handleInputChange(e)} onChange={handleTextInput} value={state.charity} type='text' name='charity' />
              {errorMessage && <p style={{ color: "red" }}>{errorMessage.charity}</p>}
              Contact name
              <input required onBlur={(e) => handleInputChange(e)} onChange={handleTextInput} value={state.name} type='text' name='name' />
              {errorMessage && <p style={{ color: "red" }}>{errorMessage.name}</p>}
              Position / role
              <input required onBlur={(e) => handleInputChange(e)} onChange={handleTextInput} value={state.position} name='position' />
              {errorMessage && <p style={{ color: "red" }}>{errorMessage.position}</p>}
              Telephone
              <input required onBlur={(e) => handleInputChange(e)} onChange={handleTextInput} value={state.tel} type='tel' name='tel' />
              {errorMessage && <p style={{ color: "red" }}>{errorMessage.tel}</p>}
              Email
              <input required onBlur={(e) => handleInputChange(e)} onChange={handleTextInput} value={state.email} type='email' name='email' />
              {errorMessage && <p style={{ color: "red" }}>{errorMessage.email}</p>}
              Website
              <input required onBlur={(e) => handleInputChange(e)} onChange={handleTextInput} value={state.website} type='text' name='website' />
              {errorMessage && <p style={{ color: "red" }}>{errorMessage.website}</p>}
              <hr />
              How much are you applying for (£)?
              <input required onBlur={(e) => handleInputChange(e)} onChange={handleTextInput} value={state.fundingrequested} type='text' name='fundingrequested' />
              {errorMessage && <p style={{ color: "red" }}>{errorMessage.fundingrequested}</p>}
              <div>
                <hr />
                <p>Please confirm whether your organisation has:</p>
                <span style={{ marginRight: "5px" }}>Public Liability Insurance (please answer yes/no):</span>
                <input required onBlur={(e) => handleInputChange(e)} onChange={handleTextInput} value={state.liability} type='text' name='liability' />
                {errorMessage && <p style={{ color: "red" }}>{errorMessage.liability}</p>}
              </div>
              <div>
                <span style={{ marginRight: "5px" }}>Safeguarding policy (please answer yes/no) :</span>
                <input required onBlur={(e) => handleInputChange(e)} onChange={handleTextInput} value={state.safeguarding} type='text' name='safeguarding' />
                {errorMessage && <p style={{ color: "red" }}>{errorMessage.safeguarding}</p>}
              </div>


              {/* **************************Text area**************************** */}
              <b>About your organisation</b>
              <p>
                Please tell us about your organisation and describe relevant previous experience and track record of
                working in your field. (200 words max).
              </p>
              <textarea required onBlur={handleTextAreaBlur} onChange={(e) => handleTextArea(e, 200)} value={state.about} rows={10} name='about'></textarea>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  {errorMessage.about && (
                    <p style={{ color: "red" }}>
                      {errorMessage.about}
                    </p>
                  )}
                  {wordOverflow.about > 0 && (
                    <p style={{ color: "red" }}>You have exceeded the word limit by {wordOverflow.about} words.</p>
                  )}
                </div>
                <span style={{ display: "flex", justifyContent: "space-between" }}>
                  {wordCounts.about || 0}/200 words
                </span>
              </div>
              <b>Short project description</b>
              <p>
                Please tell us what you'd like to do; explain the proposed activities, target groups, partners,
                location/setting and outputs. (500 words max).
              </p>
              <textarea required onBlur={handleTextAreaBlur} onChange={(e) => handleTextArea(e, 500)} value={state.project} rows={15} name='project'></textarea>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  {errorMessage.project && (
                    <p style={{ color: "red" }}>
                      {errorMessage.project}
                    </p>
                  )}
                  {wordOverflow.project > 0 && (
                    <p style={{ color: "red" }}>You have exceeded the word limit by {wordOverflow.project} words.</p>
                  )}
                </div>
                <span style={{ display: "flex", justifyContent: "space-between" }}>
                  {wordCounts.project || 0}/500 words
                </span>
              </div>
              <b>Timeframe</b>
              <p>Please explain when the project will take place. (50 words max).</p>
              <textarea required onBlur={handleTextAreaBlur} onChange={(e) => handleTextArea(e, 50)} value={state.timeframe} name='timeframe'></textarea>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  {errorMessage.timeframe && (
                    <p style={{ color: "red" }}>
                      {errorMessage.timeframe}
                    </p>
                  )}
                  {wordOverflow.timeframe > 0 && (
                    <p style={{ color: "red" }}>You have exceeded the word limit by {wordOverflow.timeframe} words.</p>
                  )}
                </div>
                <span style={{ display: "flex", justifyContent: "space-between" }}>
                  {wordCounts.timeframe || 0}/50 words
                </span>
              </div>
              <b>Who will your project reach?</b>
              <p>
                Please tell us about the participants or audience members you hope to engage and explain how you will
                reach them (e.g. participant recruitment plans, audience / marketing plans). Also tell us how many
                people you hope to reach. (200 words max).
              </p>
              <textarea required onBlur={handleTextAreaBlur} onChange={(e) => handleTextArea(e, 200)} value={state.outreach} rows={10} name='outreach'></textarea>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  {errorMessage.outreach && (
                    <p style={{ color: "red" }}>
                      {errorMessage.outreach}
                    </p>
                  )}
                  {wordOverflow.outreach > 0 && (
                    <p style={{ color: "red" }}>You have exceeded the word limit by {wordOverflow.outreach} words.</p>
                  )}
                </div>
                <span style={{ display: "flex", justifyContent: "space-between" }}>
                  {wordCounts.outreach || 0}/200 words
                </span>
              </div>
              <b>Demand for your work</b>
              <p>
                How do you know there is demand for your work? How do you know your project is needed? (200 words max).
              </p>
              <textarea required onBlur={handleTextAreaBlur} onChange={(e) => handleTextArea(e, 200)} value={state.demand} rows={10} name='demand'></textarea>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  {errorMessage.demand && (
                    <p style={{ color: "red" }}>
                      {errorMessage.demand}
                    </p>
                  )}
                  {wordOverflow.demand > 0 && (
                    <p style={{ color: "red" }}>You have exceeded the word limit by {wordOverflow.demand} words.</p>
                  )}
                </div>
                <span style={{ display: "flex", justifyContent: "space-between" }}>
                  {wordCounts.demand || 0}/200 words
                </span>
              </div>
              <b>Project impact and outcomes</b>
              <p>
                What overall impact do you hope to achieve? What outcomes will your project have?
                <br />
                <em>An outcome is a change in skills, attitude or behaviour and must be measurable.&nbsp;</em>
                (200 words max).
              </p>
              <textarea required onBlur={handleTextAreaBlur} onChange={(e) => handleTextArea(e, 200)} value={state.impact} rows={10} name='impact'></textarea>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  {errorMessage.impact && (
                    <p style={{ color: "red" }}>
                      {errorMessage.impact}
                    </p>
                  )}
                  {wordOverflow.impact > 0 && (
                    <p style={{ color: "red" }}>You have exceeded the word limit by {wordOverflow.impact} words.</p>
                  )}
                </div>
                <span style={{ display: "flex", justifyContent: "space-between" }}>
                  {wordCounts.impact || 0}/200 words
                </span>
              </div>
              <b>Evaluation</b>
              <p>
                Please describe how you will evaluate your project. (200 words max).
                <br />
                <em>
                  NB it is not essential for projects to have an external evaluator or to produce lengthy evaluation
                  documents. However, we would like to see that you have processes in place to collect qualitative and
                  quantative data / feedback in order to assess whether your project successfully achieves the desired
                  outcomes.
                </em>
              </p>
              <textarea
                required
                onBlur={handleTextAreaBlur}
                onChange={(e) => handleTextArea(e, 200)}
                value={state.evaluation}
                rows={10}
                name='evaluation'
              ></textarea>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  {errorMessage.evaluation && (
                    <p style={{ color: "red" }}>
                      {errorMessage.evaluation}
                    </p>
                  )}
                  {wordOverflow.evaluation > 0 && (
                    <p style={{ color: "red" }}>You have exceeded the word limit by {wordOverflow.evaluation} words.</p>
                  )}
                </div>
                <span style={{ display: "flex", justifyContent: "space-between" }}>
                  {wordCounts.evaluation || 0}/200 words
                </span>
              </div>


              {/* ***************project expenses***************** */}
              <b>Project budget</b>
              <p>
                <b>Please note: For security, data in this section does not get saved between sessions.</b> <br />
                If you close this window before submitting, you will need to fill in the budget section again.
              </p>
              <p>
                <b>Expenses</b>
              </p>
              {expensesInputList.map((x, i) => {
                return (
                  <div key={i}>
                    <div className='expenses-inputs'>
                      <input
                        required
                        style={{ width: "35%" }}
                        placeholder='Expenditure item'
                        onChange={(e) => handleFinanceInputChange(e, i, 'expenses', 'Expenditure')}
                      />
                      <input
                        required
                        style={{ width: "40%" }}
                        placeholder='Details'
                        onChange={(e) => handleFinanceInputChange(e, i, 'expenses', 'Details')}
                      />
                      <input
                        style={{ width: "11%" }}
                        type='number'
                        min={0}
                        placeholder='Cost'
                        value={x.Cost}
                        onChange={(e) => {
                          handleFinanceInputChange(e, i, 'expenses', 'Cost');
                          setExpConfirmed(false);
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: 10, marginTop: 5 }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          {expensesInputList.length !== 1 && (
                            <button
                              style={{ marginRight: 5 }} onClick={(e) => handleRemoveEntry(e, x, i)}>
                              Remove
                            </button>
                          )}

                          <button
                            onClick={(e) => handleAddEntry(e, 'expenses')}>Add another expense</button>
                        </div>
                        {expensesInputList.length - 1 === i && (
                          <button
                            disabled={expConfirmed}
                            style={{ marginRight: 5 }}
                            onClick={(e) => handleTotalExp(e, x, i)}
                          >
                            Confirm
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              <br />
              <div className='text-right'>
                <span>
                  <strong>Total projected expenses: </strong>
                </span>
                <input value={"£" + totalExpense} type='text' placeholder='automatically updates' />
              </div>
              <p>
                <b>Income</b>
              </p>
              <p>Please include this application as a source of income.</p>
              {incomeInputList.map((x, i) => (
                <div>
                  <div className='expenses-inputs'>
                    <input
                      style={{ width: "35%" }}
                      placeholder='Income source'
                      value={x.Income}
                      onChange={(e) => {
                        handleFinanceInputChange(e, i, 'income', 'Income');
                      }}
                    />
                    <select
                      onChange={(e) => {
                        handleFinanceInputChange(e, i, 'income', 'Confirmed');
                      }}
                    >
                      <option value='please choose'>Indicate income status</option>
                      <option value='Confirmed'>Confirmed</option>
                      <option value='Pending'>Pending</option>
                    </select>
                    <input
                      style={{ width: "11%" }}
                      type='number'
                      min={0}
                      placeholder='Amount'
                      value={x.Amount}
                      onChange={(e) => {
                        handleFinanceInputChange(e, i, 'income', 'Amount');
                        setIncConfirmed(false);
                      }}
                    />
                  </div>
                  <div style={{ marginBottom: 10, marginTop: 5 }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        {incomeInputList.length !== 1 && (
                          <button
                            style={{ marginRight: 5 }} onClick={(e) => handleRemoveEntry(e, x, i)}>
                            Remove
                          </button>
                        )}

                        <button
                          onClick={(e) => handleAddEntry(e, 'income')}>Add another income</button>
                      </div>
                      {incomeInputList.length - 1 === i && (
                        <button
                          disabled={incConfirmed || !incomeInputList[i].Confirmed}
                          style={{ marginRight: 5 }}
                          onClick={(e) => handleTotalInc(e, x, i)}
                        >
                          Confirm
                        </button>
                      )}
                    </div>
                  </div>
                  <hr />
                </div>
              ))}
              <br />
              <div>
                <p>Total Pending Income: £{state.pendingIncome}</p>
                <p>Total Confirmed Income: £{state.confirmedIncome} </p>
              </div>
              <div className='text-right'>
                <span>
                  <strong>Total projected income: </strong>
                </span>
                <input
                  value={"£" + totalIncome}
                  required
                  type='text'
                  placeholder='automatically updates'
                />
              </div>
              <hr />
              <div className='form-buttons'>
                {submitError && (
                  <p style={{ color: "red", width: "100%" }}>{submitError}</p>
                )}
                {submitted ? (
                  <p style={{ width: "100%" }}>
                    Thank you — your application has been submitted.
                  </p>
                ) : (
                  <button
                    disabled={submitting || requiredFieldsMissing}
                    type="submit"
                    style={{ width: "45%", color: "white" }}
                    className='btn btn-info'>
                    {submitting ? "Sending…" : "Submit"}
                  </button>
                )}
                <button
                  style={{ width: "45%", color: "red" }}
                  className='button'
                  type='button'
                  onClick={props.closeModal}
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ApplicationForm2;
